import { EscalationFilters } from "../../../../../../../../Models/escalatedPageModels";
import { DATE_SELECTION_OPTIONS } from "../../../../../../../../constants/dateFormat";
import {
    FilterOption,
    FilterSelectOption,
} from "../../../../../../../../Components/FilterPopup/filterPopup.models";
import {
    CREATED_AT_KEY,
    CREATED_BY_KEY,
    CUSTOM_END_DATE_KEY,
    CUSTOM_START_DATE_KEY,
    ESCALATION_TYPE_KEY,
    STATUS_KEY,
} from "../../../../../../escalatedPage.constants";

export const getEscalationFilterOptions = (
    draftFilters: EscalationFilters,
    updateDraft: <K extends keyof EscalationFilters>(key: K, value: EscalationFilters[K]) => void,
    createdByOptions: FilterSelectOption[],
    escalationStatusOptions: FilterSelectOption[],
    escalationOptions: FilterSelectOption[]
): FilterOption[] => [
    {
        label: "Created Timestamp",
        type: "date",
        options: DATE_SELECTION_OPTIONS,
        value: draftFilters.createdAt,
        handleChange: (value) => updateDraft(CREATED_AT_KEY, value as string),
        customStartDate: draftFilters.customStartDate ?? null,
        customEndDate: draftFilters.customEndDate ?? null,
        onCustomRangeChange: (start, end) => {
            updateDraft(CUSTOM_START_DATE_KEY, start);
            updateDraft(CUSTOM_END_DATE_KEY, end);
        },
    },
    {
        label: "Created by",
        type: "select",
        options: createdByOptions,
        value: draftFilters.createdBy,
        handleChange: (value) => updateDraft(CREATED_BY_KEY, value as string[]),
    },
    {
        label: "Status",
        type: "select",
        options: escalationStatusOptions,
        value: draftFilters.status,
        handleChange: (value) => updateDraft(STATUS_KEY, value as string[]),
    },
    {
        label: "Escalated Type",
        type: "select",
        options: escalationOptions,
        value: draftFilters.escalationType,
        handleChange: (value) => updateDraft(ESCALATION_TYPE_KEY, value as string[]),
    },
];
